var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "loading_svg__spin",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF5D6",
  d: "M26 13c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0s13 5.82 13 13M3.9 13a9.1 9.1 0 1 0 18.2 0 9.1 9.1 0 0 0-18.2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFBE00",
  d: "M24.05 13c1.077 0 1.965.878 1.804 1.943a13 13 0 0 1-10.911 10.911C13.878 26.015 13 25.127 13 24.05s.883-1.93 1.935-2.158a9.1 9.1 0 0 0 6.957-6.957C22.12 13.883 22.973 13 24.05 13"
})));
export default SvgLoading;